module.exports = __webpack_public_path__ + "img/loginBg.c391d39c.png";